module.exports = __webpack_public_path__ + "img/ftth_one_mini.352d15b4.png";